import { mutatorAction } from 'satcheljs';
import getAccountBySourceId from '../selectors/getAccountBySourceId';
import getAccountSourceListStore from '../store/accountSourceListStore';
import { logStartUsage } from 'owa-analytics-start';

/**
 * Update the accountDescription of the specified Coprincipal account source in the store
 */
const updateCoprincipalAccountDescriptionMutator: (
    sourceId: string,
    accountDescription: string
) => void = mutatorAction(
    'UPDATE_COPRINCIPAL_ACCOUNT_DESCRIPTION',
    function (sourceId: string, accountDescription: string): void {
        if (!getAccountBySourceId(sourceId)) {
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         * undefined
         *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
         (https://aka.ms/OWALintWiki)
                     * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
                     * undefined
                     *	> MailboxInfo must be passed into the function to identify the account.
                     (https://aka.ms/OWALintWiki)
                                 * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                                 *	> Invalid Outlook telemetry EventName "accountDescription_UpdateCoprincipalSourceIdNotFound": must start with a capital letter (A–Z). */
            logStartUsage('accountDescription_UpdateCoprincipalSourceIdNotFound', undefined);
            return;
        }
        const store = getAccountSourceListStore();
        for (const source of store.sources) {
            if (source.sourceId === sourceId) {
                source.accountDescription = accountDescription;
            }
        }
    }
);
export default updateCoprincipalAccountDescriptionMutator;
